<template>
  <div
    class="conversation"
    :class="{
      active: isActiveChat,
      'unread-chat': hasUnread,
      'has-inbox-name': showInboxName,
      'conversation-selected': selected,
    }"
    @mouseenter="onCardHover"
    @mouseleave="onCardLeave"
    @click="onCardClick"
    @contextmenu="openContextMenu($event)"
  >
    <service-timer
      :initialize-control-timing="initializeControlTiming"
      :progress="progress"
    >
      <label v-if="hovered || selected" class="checkbox-wrapper" @click.stop>
        <input
          :value="selected"
          :checked="selected"
          class="checkbox"
          type="checkbox"
          @change="onSelectConversation($event.target.checked)"
        />
      </label>
      <thumbnail
        v-if="bulkActionCheck"
        :src="
          currentContact && currentContact.thumbnail
            ? currentContact.thumbnail
            : ''
        "
        :badge="inboxBadge"
        :username="
          currentContact && currentContact.name
            ? currentContact.name
            : 'Desconhecido'
        "
        :status="
          currentContact && currentContact.availability_status
            ? currentContact.availability_status
            : 'offline'
        "
        size="40px"
        :is-chat="true"
        stroke-width="3"
      />
    </service-timer>
    <div class="conversation--details columns">
      <!-- Linha 1: nome do contato + horário (igual .conv-row1 do protótipo) -->
      <div class="conv-row1">
        <h4 v-if="!isInternalChat" class="conversation--user">
          {{ prefix }} {{ currentContact.name }}
        </h4>
        <div v-else class="conversation--user conversation--members">
          <span class="badge badge--blue">{{ conversationMembers.from }}</span>
          <span class="badge badge--green">{{ conversationMembers.to }}</span>
        </div>
        <span v-if="lastMessageInChat" class="conversation--time">
          <time-ago
            :last-activity-timestamp="lastMessageInChat.created_at"
            :created-at-timestamp="timestampFormatter"
          />
        </span>
      </div>

      <p v-if="lastMessageInChat" class="conversation--message">
        <fluent-icon
          v-if="isMessagePrivate"
          size="16"
          class="message--attachment-icon last-message-icon"
          icon="lock-closed"
        />
        <fluent-icon
          v-else-if="messageByAgent"
          size="16"
          class="message--attachment-icon last-message-icon"
          icon="arrow-reply"
        />
        <fluent-icon
          v-else-if="isMessageAnActivity"
          size="16"
          class="message--attachment-icon last-message-icon"
          icon="info"
        />
        <span
          v-if="lastMessageInChat.content && !lastMessageInChat.attachments"
        >
          {{ parsedLastMessage }}
        </span>
        <span v-else-if="lastMessageInChat.attachments">
          <fluent-icon
            v-if="attachmentIcon"
            size="16"
            class="message--attachment-icon"
            :icon="attachmentIcon"
          />
          {{ this.$t(`${attachmentMessageContent}`) }}
        </span>
        <span v-else>
          {{ $t('CHAT_LIST.NO_CONTENT') }}
        </span>
      </p>
      <p v-else class="conversation--message">
        <fluent-icon size="16" class="message--attachment-icon" icon="info" />
        <span>
          {{ this.$t(`CHAT_LIST.NO_MESSAGES`) }}
        </span>
      </p>
      <!-- Linha 3: caixa/atribuído/prioridade/etiquetas + não-lidas (igual .conv-row3) -->
      <div class="conv-row3">
        <inbox-name v-if="showInboxName" :inbox="inbox" class="conv-chip" />
        <span
          v-if="showAssignee && assignee && !isInternalChat"
          class="label assignee-label text-truncate"
        >
          <fluent-icon icon="person" size="12" />
          {{ assignee.name ? assignee.name : '' }}
        </span>
        <priority-mark :priority="chat.priority" />
        <card-labels :conversation-id="chat.id" />
        <span
          v-if="chat.order && chat.status === 'pending'"
          class="position-queue"
        >
          #{{ chat.order }}
        </span>
        <span class="unread">{{ unreadCount }}</span>
      </div>
    </div>
    <woot-context-menu
      v-if="showContextMenu"
      ref="menu"
      :x="contextMenu.x"
      :y="contextMenu.y"
      @close="closeContextMenu"
    >
      <conversation-context-menu
        :status="chat.status"
        :chat_id="chat.id"
        :chat="chat"
        :inbox-id="inbox.id"
        :inbox="inbox"
        :priority="chat.priority"
        :has-unread-messages="hasUnread"
        @update-conversation="onUpdateConversation"
        @assign-agent="onAssignAgent"
        @assign-label="onAssignLabel"
        @assign-team="onAssignTeam"
        @open-modal="onOpenModal"
        @mark-as-unread="markAsUnread"
        @assign-priority="assignPriority"
      />
    </woot-context-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import Thumbnail from '../Thumbnail';
import conversationMixin from '../../../mixins/conversations';
import timeMixin from '../../../mixins/time';
import router from '../../../routes';
import { frontendURL, conversationUrl } from '../../../helper/URLHelper';
import InboxName from '../InboxName';
import inboxMixin from 'shared/mixins/inboxMixin';
import ConversationContextMenu from './contextMenu/Index.vue';
import alertMixin from 'shared/mixins/alertMixin';
import TimeAgo from 'dashboard/components/ui/TimeAgo';
import CardLabels from './conversationCardComponents/CardLabels.vue';
import PriorityMark from './PriorityMark.vue';
import ServiceTimer from './ServiceTimer.vue';
const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
  contact: 'person',
};

export default {
  components: {
    CardLabels,
    InboxName,
    Thumbnail,
    ConversationContextMenu,
    TimeAgo,
    PriorityMark,
    ServiceTimer,
  },

  mixins: [
    inboxMixin,
    timeMixin,
    conversationMixin,
    messageFormatterMixin,
    alertMixin,
  ],
  props: {
    activeLabel: {
      type: String,
      default: '',
    },
    chat: {
      type: Object,
      default: () => {},
    },
    hideInboxName: {
      type: Boolean,
      default: false,
    },
    hideThumbnail: {
      type: Boolean,
      default: false,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
    conversationType: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionCount: 1,
      seletedTimestamp: 0,
      currentDate: new Date(),
      addTime: '00:00',
      hovered: false,
      showContextMenu: false,
      contextMenu: {
        x: null,
        y: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      inboxesList: 'inboxes/getInboxes',
      activeInbox: 'getSelectedInbox',
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      agentContact: 'contacts/getContactByAgentId',
    }),
    groupAttributeData() {
      return this.$store.getters['attributes/getGroupAttributesList'];
    },
    isInternalChat() {
      return this.inbox?.channel_type === 'Channel::Internal';
    },
    bulkActionCheck() {
      return !this.hideThumbnail && !this.hovered && !this.selected;
    },
    chatMetadata() {
      return this.chat.meta || {};
    },
    progress() {
      return this.calculatePercentageProgress;
    },
    prefix() {
      if (this.inbox?.enable_contact_classification) {
        const attributeType = this.inbox.classification_type;
        const classifications = this.inbox.contact_classification.filter(
          item => item.attribute_type === attributeType
        );
        const customAttributes = this.currentContact.custom_attributes;

        if (attributeType == 'contact_attributes') {
          for (const classification of classifications) {
            const attributeName = classification.attribute_name;

            if (customAttributes.hasOwnProperty(attributeName)) {
              let attributeValue = customAttributes[attributeName];
              const condition = classification.condition;
              let comparisonValue = classification.value;

              if (!isNaN(Number(attributeValue))) {
                attributeValue = Number(attributeValue);
              }
              if (!isNaN(Number(comparisonValue))) {
                comparisonValue = Number(comparisonValue);
              }

              if (
                this.compareValues(attributeValue, condition, comparisonValue)
              ) {
                return classification.classification;
              }
            }
          }
        } else if (
          attributeType == 'group_attributes' &&
          this.currentContact?.workplace
        ) {
          const contactWorkplace = this.groupAttributeData?.find(
            item => item.id === this.currentContact.workplace
          );

          if (contactWorkplace) {
            for (const classification of classifications) {
              let attributeValue =
                contactWorkplace[classification.attribute_name];
              const condition = classification.condition;
              let comparisonValue = classification.value;

              if (!isNaN(Number(attributeValue))) {
                attributeValue = this.extractNumbers(attributeValue);
              }
              if (!isNaN(Number(comparisonValue))) {
                comparisonValue = Number(comparisonValue);
              }

              if (
                this.compareValues(attributeValue, condition, comparisonValue)
              ) {
                return classification.classification;
              }
            }
          }
        }
      } else {
        return null;
      }
    },
    assignee() {
      const isChannelInternal = this.inbox.channel_type === 'Channel::Internal';
      if (isChannelInternal) {
        return this.chatMetadata?.assignee?.name;
      }
      return this.chatMetadata.assignee || {};
    },
    conversationMe() {
      const isChannelInternal = this.inbox.channel_type === 'Channel::Internal';
      const currentUserIsAssignee =
        this.chatMetadata?.assignee?.id === this.currentUser?.id;
      const currentUserIsSender =
        this.chatMetadata?.sender?.id === this.currentUser?.id;

      return (
        isChannelInternal && (currentUserIsAssignee || currentUserIsSender)
      );
    },
    conversationMembers() {
      const assignee = this.chatMetadata?.assignee;
      const sender = this.chatMetadata?.sender;
      return {
        from: assignee?.name || '',
        to: sender?.name || '',
      };
    },
    initializeControlTiming() {
      const isAssigned =
        this?.assignee && Object.keys(this?.assignee)?.length > 0;
      const isChatOpen = this.chat.status === 'open';
      const hasNoGroup = this.chat?.group == null;
      const hasSelectedTimestamp = this.seletedTimestamp !== null;

      const slaCondition = this.inbox.sla_enabled && isAssigned;
      const unassignedCondition =
        this.inbox.unassigned_status_time_enabled && !isAssigned;

      return (
        (slaCondition || unassignedCondition) &&
        isChatOpen &&
        hasNoGroup &&
        hasSelectedTimestamp
      );
    },
    currentContact() {
      if (
        this.chatMetadata?.assignee?.id !== this.currentUser?.id &&
        (this?.chat?.channel === 'Channel::Internal' ||
          this?.chat?.meta?.channel === 'Channel::Internal')
      ) {
        return this.chatMetadata.assignee;
      }

      return this.$store.getters['contacts/getContact'](
        this.chatMetadata.sender.id
      );
    },
    lastMessageFileType() {
      const lastMessage = this.lastMessageInChat;
      const attachments = lastMessage.attachments;

      if (attachments?.length) {
        const fileType = attachments?.[0]?.file_type;

        return fileType || 'file';
      }
      return null;
    },

    attachmentIcon() {
      return ATTACHMENT_ICONS[this.lastMessageFileType];
    },

    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },

    isActiveChat() {
      return this.currentChat.id === this.chat.id;
    },

    unreadCount() {
      if (!this.chat.group) {
        return this.chat.unread_count > 9 ? '9+' : this.chat.unread_count;
      }
      return this.chat.unread_count > 999 ? '999+' : this.chat.unread_count;
    },

    hasUnread() {
      return this.chat.unread_count > 0;
    },

    isInboxNameVisible() {
      return !this.activeInbox;
    },

    lastMessageInChat() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.seletedTimestamp =
        this.optionAccoutantMessage === 2
          ? this.chat?.timestamp
          : this.chat?.last_update_client;
      return this.lastMessage(this.chat) || {};
    },
    optionAccoutantMessage() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.optionCount =
        this?.assignee && Object.keys(this?.assignee)?.length === 0
          ? this.inbox?.unassigned_timer_accountant
          : this.inbox?.sla_timer_accountant;
      return this.optionCount;
    },

    calculatePercentageProgress() {
      try {
        let dateString = this.dateFormat(this.seletedTimestamp);
        let dateInitial = this.parseDate(dateString);
        let endDate = new Date(dateInitial);
        this.addTimeToDate(endDate, this.addTimeCount());

        const totalDuration = endDate - dateInitial;
        const elapsedDuration = this.currentDate - dateInitial;

        let percentagePassed = (elapsedDuration / totalDuration) * 100;
        percentagePassed = Math.min(percentagePassed, 100);
        const percentageRemaining = Math.max(100 - percentagePassed, 0);

        return percentageRemaining;
      } catch (error) {
        return 0;
      }
    },
    messageByAgent() {
      const lastMessage = this.lastMessageInChat;
      const { message_type: messageType } = lastMessage;
      return messageType === MESSAGE_TYPE.OUTGOING;
    },

    isMessageAnActivity() {
      const lastMessage = this.lastMessageInChat;
      const { message_type: messageType } = lastMessage;

      return messageType === MESSAGE_TYPE.ACTIVITY && !lastMessage?.additional_attributes?.wise?.status;
    },

    isMessagePrivate() {
      const lastMessage = this.lastMessageInChat;
      const { private: isPrivate } = lastMessage;
      return isPrivate;
    },

    timestampFormatter() {
      return new Date(this.chat.created_at).getTime()/1000;
    },

    parsedLastMessage() {
      const { content_attributes: contentAttributes } = this.lastMessageInChat;
      const { email: { subject } = {} } = contentAttributes || {};
      return this.getPlainText(subject || this.lastMessageInChat.content);
    },

    inbox() {
      const { inbox_id: inboxId } = this.chat;
      const stateInbox = this.$store.getters['inboxes/getInbox'](inboxId);
      return stateInbox;
    },

    showInboxName() {
      return (
        !this.hideInboxName &&
        this.isInboxNameVisible &&
        this.inboxesList.length > 1
      );
    },
    inboxName() {
      const stateInbox = this.inbox;
      return stateInbox.name || '';
    },
    // Selo do canal sobreposto ao avatar (WhatsApp/Instagram/etc.), igual .conv-av .ch do protótipo
    inboxBadge() {
      const type = this.inbox?.channel_type;
      if (this.isAWhatsAppChannel) {
        return 'whatsapp';
      }
      if (this.isATwilioSMSChannel || type === 'Channel::Sms') {
        return 'sms';
      }
      return (
        {
          'Channel::FacebookPage': 'facebook',
          'Channel::TwitterProfile': 'twitter-tweet',
          'Channel::Line': 'Channel::Line',
          'Channel::Telegram': 'Channel::Telegram',
        }[type] || ''
      );
    },
  },
  watch: {
    'chat.timestamp'(newTimestamp, oldTimestamp) {
      if (newTimestamp !== oldTimestamp && this.optionCount === 1) {
        this.$store.dispatch('getConversation', this.chat.id);
      }
    },
  },
  mounted() {
    this.$store.dispatch('attributes/getGroupAttributes');
    this.interval = setInterval(() => {
      this.currentDate = new Date();
    }, 1000);
  },

  methods: {
    extractNumbers(input) {
      if (typeof input !== 'string') {
        input = String(input);
      }
      const numbers = input.replace(/\D/g, '');
      return parseInt(numbers, 10) / 100;
    },
    addTimeCount() {
      return this.assignee && Object.keys(this?.assignee).length === 0
        ? this.inbox?.unassigned_timer
        : this.inbox?.sla_timer;
    },
    parseDate(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart?.split('/')?.map(Number);
      const [hour, minute] = timePart?.split(':')?.map(Number);

      return new Date(year, month - 1, day, hour, minute);
    },
    addTimeToDate(date, timeString) {
      if (timeString && typeof timeString === 'string') {
        const parts = timeString.split(':');
        if (parts.length === 2) {
          const hours = parseInt(parts[0], 10);
          const minutes = parseInt(parts[1], 10);
          if (!Number.isNaN(hours) && !Number.isNaN(minutes)) {
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
          }
        }
      }
    },
    compareValues(attributeValue, condition, comparisonValue) {
      switch (condition) {
        case '>':
          return attributeValue > comparisonValue;
        case '>=':
          return attributeValue >= comparisonValue;
        case '<':
          return attributeValue < comparisonValue;
        case '<=':
          return attributeValue <= comparisonValue;
        case '==':
          return attributeValue === comparisonValue;
        case '!=':
          return attributeValue !== comparisonValue;
        default:
          return false;
      }
    },
    onCardClick(e) {
      const { activeInbox, chat } = this;
      const path = frontendURL(
        conversationUrl({
          accountId: this.accountId,
          activeInbox,
          id: chat.id,
          label: this.activeLabel,
          teamId: this.teamId,
          foldersId: this.foldersId,
          conversationType: this.conversationType,
        })
      );

      if (e.metaKey || e.ctrlKey) {
        window.open(
          window.chatwootConfig.hostURL + path,
          '_blank',
          'noopener noreferrer nofollow'
        );
        return;
      }
      if (this.isActiveChat) {
        return;
      }

      router.push({ path });
    },
    onCardHover() {
      this.hovered = !this.hideThumbnail;
    },
    onCardLeave() {
      this.hovered = false;
    },
    onSelectConversation(checked) {
      const action = checked ? 'select-conversation' : 'de-select-conversation';
      this.$emit(action, this.chat.id, this.inbox.id);
    },
    openContextMenu(e) {
      e.preventDefault();
      this.$emit('context-menu-toggle', true);
      this.contextMenu.x = e.pageX || e.clientX;
      this.contextMenu.y = e.pageY || e.clientY;
      this.showContextMenu = true;
    },
    closeContextMenu() {
      this.$emit('context-menu-toggle', false);
      this.showContextMenu = false;
      this.contextMenu.x = null;
      this.contextMenu.y = null;
    },
    onUpdateConversation(status, snoozedUntil) {
      this.closeContextMenu();
      this.$emit(
        'update-conversation-status',
        this.chat.id,
        status,
        snoozedUntil
      );
    },
    async onOpenModal(value) {
      this.$emit('open-modal', value);
      this.closeContextMenu();
    },
    async onAssignAgent(agent) {
      this.$emit('assign-agent', agent, [this.chat.id]);
      this.closeContextMenu();
    },
    async onAssignLabel(label) {
      this.$emit('assign-label', [label.title], [this.chat.id]);
      this.closeContextMenu();
    },
    async onAssignTeam(team) {
      this.$emit('assign-team', team, this.chat.id);
      this.closeContextMenu();
    },
    async markAsUnread() {
      this.$emit('mark-as-unread', this.chat.id);
      this.closeContextMenu();
    },
    async assignPriority(priority) {
      this.$emit('assign-priority', priority, this.chat.id);
      this.closeContextMenu();
    },
  },
};
</script>
<style lang="scss" scoped>
// Avatar alinhado ao topo do card (linha do nome), igual ao .conv-av do protótipo
.conversation ::v-deep .user-thumbnail-box {
  margin-top: 0;
}

.conversation-selected {
  background: var(--surface-2, var(--s-50)) !important;
}

.checkbox-wrapper {
  margin-top: 0;
}

.last-message-icon {
  color: var(--s-600);
}

// Etiquetas / atribuído na linha 3 — visual de tag discreta do protótipo
.conv-row3 {
  ::v-deep .conv-chip,
  .assignee-label {
    background: var(--surface-2, var(--s-50));
    border-radius: 6px;
    color: var(--s-600);
    font-size: var(--font-size-mini);
    font-weight: var(--font-weight-medium);
    line-height: 1.4;
    margin: 0;
    max-width: 14rem;
    padding: 2px 7px;
  }

  .assignee-label {
    align-items: center;
    display: inline-flex;
    gap: var(--space-micro);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // CardLabels não deve empurrar o contador; mantém as pílulas inline
  ::v-deep .label-container {
    margin: 0;
    min-width: 0;

    .labels-wrap {
      gap: var(--space-smaller);
      margin: 0;
    }
  }
}

.message--attachment-icon {
  margin-top: var(--space-minus-micro);
  vertical-align: middle;
}

.checkbox-wrapper {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin-top: 13px;
  cursor: pointer;

  input[type='checkbox'] {
    margin: var(--space-zero);
    cursor: pointer;
  }
}

.conversation-members {
  display: flex;
  gap: 8px;
  align-items: center;
}

.position-queue {
  color: var(--s-500);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);
  margin-right: var(--space-small);
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  color: #5c5c5c;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 12px;
}

.badge--blue {
  background-color: hsl(211, 99%, 72%);
}

.badge--green {
  background-color: hsl(211, 99%, 72%);
}
</style>
